import _0x291399 from'./setBreakpoint.js';import _0x501087 from'./getBreakpoint.js';export default{'setBreakpoint':_0x291399,'getBreakpoint':_0x501087};